// src/components/RecentBallsBar.js
import React from 'react';
import './RecentBallsBar.css'; // We'll create this CSS file next
import { getLetterForBall } from '../bingoLogic';

function RecentBallsBar({ drawnBallsHistory }) {
  // Get the last 5 balls (or fewer if not enough drawn)
  // drawnBallsHistory is already newest first, so we take the first 5
  // The current ball is drawnBallsHistory[0], so recent are 1 through 5
  const displayBalls = drawnBallsHistory.slice(0, 10); // Show current + next 4, or just first 5 drawn

  return (
    <div className="recent-balls-bar-container">
      <h3 className="recent-balls-title">RECENTLY CALLED</h3>
      <div className="recent-balls-list-large">
        {displayBalls.length > 0 ? (
          displayBalls.map((ball, index) => (
            <div
              key={`${ball}-${index}`} // Add index to key for potential duplicates if history isn't strictly unique
              className={`recent-ball-item-large ${index === 0 ? 'is-current-in-bar' : ''}`}
            >
              <span className="recent-ball-letter-large">{getLetterForBall(ball)}</span>
              <span className="recent-ball-number-large">{ball}</span>
            </div>
          ))
        ) : (
          // Placeholder if no balls are drawn yet, or to fill up to 5 spaces
          Array.from({ length: 10 }).map((_, i) => (
            <div key={`placeholder-${i}`} className="recent-ball-item-large placeholder-ball-large">
              <span className="recent-ball-letter-large">-</span>
              <span className="recent-ball-number-large">--</span>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default RecentBallsBar;
